import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Axios from 'axios'

Vue.config.productionTip = false

Vue.prototype.$http = Axios;

Vue.prototype.$backend = 'https://riot.fm'
//Vue.prototype.$backend = 'http://localhost:7575'

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

new Vue({
  store,
  router: router,
  render: h => h(App),
}).$mount('#app')
